module.exports = __webpack_public_path__ + "static/media/user.2a5f6131.png";